{
  "title": "Mind Blank",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level abjuration",
  "level": 8,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "24 hours",
  "description": [
    "Until the spell ends, one willing creature you touch is immune to psychic damage, any effect that would sense its emotions or read its thoughts, divination spells, and the charmed condition. The spell even foils wish spells and spells or effects of similar power used to affect the target's mind or to gain information about the target."
  ],
  "spellLists": ["bard", "wizard"]
}
